import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ChevronDown = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M11.7125 15.825a1.1998 1.1998 0 01-.4287-.0775c-.1367-.0517-.2611-.1334-.3731-.2452l-4.594-4.594C6.1056 10.6969 6 10.4317 6 10.1125c0-.3192.1056-.5844.3167-.7957C6.5282 9.1056 6.7934 9 7.1125 9c.3192 0 .5844.1056.7957.3168l3.8043 3.8045 3.8042-3.8045c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7958.3168.2111.2113.3167.4765.3167.7957s-.1056.5844-.3167.7958l-4.594 4.594c-.112.1118-.2364.1935-.373.2452a1.2007 1.2007 0 01-.4288.0775z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M11.7125 15.825a1.2002 1.2002 0 01-.4287-.0775c-.1367-.0517-.2611-.1334-.3731-.2452l-4.594-4.594C6.1056 10.6969 6 10.4317 6 10.1125c0-.3192.1056-.5844.3167-.7957C6.5282 9.1056 6.7934 9 7.1125 9c.3192 0 .5844.1056.7957.3168l3.8043 3.8045 3.8042-3.8045c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7958.3168.2111.2113.3167.4765.3167.7957s-.1056.5844-.3167.7958l-4.594 4.594c-.112.1118-.2364.1935-.373.2452a1.2007 1.2007 0 01-.4288.0775z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M11.7125 15.825a1.1998 1.1998 0 01-.4287-.0775c-.1367-.0517-.2611-.1334-.3731-.2452l-4.594-4.594C6.1056 10.6969 6 10.4317 6 10.1125c0-.3192.1056-.5844.3167-.7957C6.5282 9.1056 6.7934 9 7.1125 9c.3192 0 .5844.1056.7957.3168l3.8043 3.8045 3.8042-3.8045c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7958.3168.2111.2113.3167.4765.3167.7957s-.1056.5844-.3167.7958l-4.594 4.594c-.112.1118-.2364.1935-.373.2452a1.2007 1.2007 0 01-.4288.0775z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M11.7125 15.825a1.2002 1.2002 0 01-.4287-.0775c-.1367-.0517-.2611-.1334-.3731-.2452l-4.594-4.594C6.1056 10.6969 6 10.4317 6 10.1125c0-.3192.1056-.5844.3167-.7957C6.5282 9.1056 6.7934 9 7.1125 9c.3192 0 .5844.1056.7957.3168l3.8043 3.8045 3.8042-3.8045c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7958.3168.2111.2113.3167.4765.3167.7957s-.1056.5844-.3167.7958l-4.594 4.594c-.112.1118-.2364.1935-.373.2452a1.2007 1.2007 0 01-.4288.0775z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ChevronDown.displayName = "ChevronDownIcon";

export { ChevronDown, ChevronDown as default };
